import { combineReducers } from 'redux';
import fileUploadReducer from './fileUploadReducer';
import manualSubmitReducer from './manualSubmitReducer';
import statusDetailsReducer from './statusDetailsReducer';
import errorReducer from './manualValidateReducer';
import manualDropDownReducer from './manualDropDownReducer';
import manualValidateReducer from './manualValidateReducer';
import commodityStateReducer from './commodityDetailsStateReducer';
import glaReducer from './esriResponseReducer';
import euPendingApprovalReducer from './euPendingApprovalReducer';
import euFileUploadReducer from './euFileUploadReducer';
export default combineReducers({
  fileUploadDetails: fileUploadReducer,
  manualEntrySubmitData: manualSubmitReducer,
  dropDownMasterData: manualDropDownReducer,
  error: errorReducer,
  statusDetails: statusDetailsReducer,
  manualValidateDetails: manualValidateReducer,
  saveForLaterList: statusDetailsReducer,
  submittedToEuList: statusDetailsReducer,
  archivedList: statusDetailsReducer,
  invalidList: statusDetailsReducer,
  pendingApprovalList: statusDetailsReducer,
  commodityState: commodityStateReducer,
  gla: glaReducer,
  euSubmittedToEuList: euPendingApprovalReducer,
  euArchivedList: euPendingApprovalReducer,
  euPendingApprovalList: euPendingApprovalReducer,
  euFileUploadDetails: euFileUploadReducer,
});
